// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip-22Jtxpt","tooltip__label":"tooltip__label-Qc_LAP1"};